import { AxiosResponse } from 'axios'
import { XENDIT_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/xendit/api'
import {
  XenditCreateIntegrationInterface,
  XenditPaymentIntegrationInterface,
  XenditUpdateIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/xendit/types'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useCreateXenditIntegration = () => {
  const { fetcher } = useFetch<
    RequestMethodsEnum.post,
    AxiosResponse<XenditPaymentIntegrationInterface>
  >({ method: RequestMethodsEnum.post })

  return {
    createXenditIntegration: (data: XenditCreateIntegrationInterface) =>
      fetcher(`${XENDIT_ACCOUNT_API}/connect`, data),
  }
}

export const useUpdateXenditIntegration = () => {
  const { fetcher } = useFetch<
    RequestMethodsEnum.put,
    AxiosResponse<XenditPaymentIntegrationInterface>
  >({ method: RequestMethodsEnum.put })

  return {
    updateXenditIntegration: async (data: XenditUpdateIntegrationInterface) =>
      await fetcher(`${XENDIT_ACCOUNT_API}/update`, data),
  }
}
